import React from "react";

/**
 * Everything the signed-in app needs (providers, routes, GraphQL) lives behind
 * this import, so sign-in starts without waiting for it. Call
 * preloadAuthenticatedApp() at startup so the chunk downloads while Auth0 and
 * the config fetch run.
 */
const loadAuthenticatedApp = () => import("./AuthenticatedApp");

export const preloadAuthenticatedApp = () => {
  void loadAuthenticatedApp().catch(() => undefined);
};

export const AuthenticatedApp = React.lazy(loadAuthenticatedApp);
